import FJHeadshotGeneratorRightContainer from './right/container/FJHeadshotGeneratorRightContainer';
import FJNavBar from '../../common/components/FJNavBar/FJNavBar';
import { useDispatch, useSelector } from 'react-redux';
import FJActionHeadshotGenerator from '../../redux/action/FJActionHeadshotGenerator';
import FJAIHeadshotIcon from '../../assets/svg/headshot-small.svg?react';
import FJMyCreationsIcon from '../../assets/svg/headshot-list.svg?react';
import FJTabGeneratingNumber from './right/view/FJTabGeneratingNumber';
import { useCallback, useEffect, useMemo } from 'react';

const FJHeadshotGenerator = () => {
    const dispatch = useDispatch();

    const tabIndex = useSelector(state => state.headshotGenerator.tabIndex);
    const isShowGeneratingHeadshotNum = useSelector(state => state.headshotGenerator.isShowGeneratingHeadshotNum);
    const generatingHeadshotNum = useSelector(state => state.headshotGenerator.generatingHeadshotNum);

    const menuList = useMemo(() => {
        return [
            { value: 'ai-headshot', name: 'ai-headshot', icon: FJAIHeadshotIcon },
            {
                value: 'my-creations',
                name: 'my-creations',
                icon: FJMyCreationsIcon,
                children: (
                    <FJTabGeneratingNumber isShow={isShowGeneratingHeadshotNum} generatingNum={generatingHeadshotNum} />
                ),
            },
        ];
    }, [isShowGeneratingHeadshotNum, generatingHeadshotNum]);

    const selectTab = useMemo(() => {
        return menuList[tabIndex].value;
    }, [menuList, tabIndex]);

    const _onChangeTabIndex = useCallback(
        value => {
            const index = menuList.findIndex(item => item.value === value);
            dispatch(FJActionHeadshotGenerator.changeTabIndexAction(index));
        },
        [dispatch, menuList],
    );

    useEffect(() => {
        dispatch(FJActionHeadshotGenerator.initPromptHeadshotAction());
    }, [dispatch]);

    return (
        <>
            <FJNavBar
                style={{ width: '250px' }}
                tabList={menuList}
                isMusicNav={true}
                selectTab={selectTab}
                onChangeTab={_onChangeTabIndex}
            />
            <FJHeadshotGeneratorRightContainer />
        </>
    );
};

export default FJHeadshotGenerator;
